import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Sora\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-sora\",\"display\":\"swap\"}],\"variableName\":\"sora\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/SmoothScroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalendlyProvider"] */ "/vercel/path0/src/components/CalendlyPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PerformanceProvider"] */ "/vercel/path0/src/contexts/PerformanceContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/tailwind.css");
